import { fetchCachedHelper } from '../../api/api'
import { categoriesActions } from './categoriesSlice'

export const getCategories = type => async dispatch => {
    dispatch(categoriesActions.getCategoriesRequest())
    try {
        const response = await fetchCachedHelper(`Coursecategory`)
        dispatch(
            categoriesActions.getCategoriesRequestSuccess({
                categories: response.data,
                type,
            })
        )
    } catch (e) {
        dispatch(categoriesActions.getCategoriesRequestError(e.message))
    }
}
